import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'textbox',
    templateUrl: './textbox.component.html',
    styleUrls: ['./textbox.component.css'],
    standalone: false
})
export class TextboxComponent {
  @Input() field: any = {};
  @Input() form: FormGroup;
  get isValid() {
    if (this.form.controls[this.field.name]) {
      return this.form.controls[this.field.name].valid;
    }
    else {
      return true;
    }
  }
  get isDirty() {
    if (this.form.controls[this.field.name]) {
      return this.form.controls[this.field.name].dirty;
    }
    else {
      return true;
    }
  }

  get errors() {
    if (this.form.controls[this.field.name]) {
      return this.form.controls[this.field.name].errors;
    }

  }

  constructor() {

  }
}
